import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Link } from '@mui/material';
import React, { FC } from 'react';
import { buildingType } from '../../models/building-type.enum';
import BuildingTypeCard from './BuildingTypeCard/BuildingTypeCard';
import styles from './BuildingTypeSelectionDialog.module.css';
import { initialPropsStepEnum, InitProperties } from '../BuildingInitialPropertiesDialog/init-props';
import { ServiceManager } from '../../../../services/service-manager';
import { explanationIds } from '../../../../common/authentication/models/user';

interface BuildingTypeSelectionDialogProps {
    open: boolean,
    buildingInitProps: InitProperties,
    setOpen: (open: boolean) => void,
    setBuildingInitProps: (buildingInitProps: InitProperties) => void
}

const BuildingTypeSelectionDialog: FC<BuildingTypeSelectionDialogProps> = ({ open, buildingInitProps, setOpen, setBuildingInitProps }) => {

    const handleClose = () => {
        setOpen(false);
    };

    const handleNext = () => {
        setBuildingInitProps({ ...buildingInitProps, stepState: initialPropsStepEnum.livingMix });
        setTimeout(() => {
            ServiceManager.explanationService.showExplanation(explanationIds.buildingLivingMix)
        }, 500)
    };

    const setBuildingType = (type: buildingType) => {
        setBuildingInitProps({ ...buildingInitProps, type })
    }

    return (
        <>
            <DialogTitle>
                <IconButton onClick={handleClose} className={styles.close} color="secondary" data-testid="close-dialog" aria-label="Dialog dicht" component="span">
                    <Close />
                </IconButton>
                <div>SELECTEER GEBOUWTYPE</div>
                <Link color="primary" target="_blank" href="https://itmoos.nl/moos-woningen">meer informatie</Link>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <span className={styles.content} id="building-types">
                        <BuildingTypeCard
                            active={buildingInitProps.type === buildingType.singleLoadedCorridor}
                            imageSrc="assets/building-types/01 galerij@2x.png"
                            title="Galerij"
                            description="tot 8 lagen"
                            autoFocus={true}
                            ps="(2-zijdig daglicht)"
                            onClick={() => { setBuildingType(buildingType.singleLoadedCorridor) }} />
                        <BuildingTypeCard
                            active={buildingInitProps.type === buildingType.doubleLoadedCorridor}
                            imageSrc="assets/building-types/02 corridor@2x.png"
                            title="Corridor"
                            description="tot 8 lagen"
                            autoFocus={false}
                            ps="(compacte woningen)"
                            onClick={() => { setBuildingType(buildingType.doubleLoadedCorridor) }} />
                        <BuildingTypeCard
                            active={buildingInitProps.type === buildingType.tower}
                            imageSrc="assets/building-types/03 toren@2x.png"
                            title="Toren"
                            description="tot 23 lagen"
                            autoFocus={false}
                            ps="(o.b.v. corridor woningen)"
                            onClick={() => { setBuildingType(buildingType.tower) }} />
                        <BuildingTypeCard
                            active={buildingInitProps.type === buildingType.rowhouse}
                            imageSrc="assets/building-types/04 rijwoning@2x.png"
                            title="Rijwoning"
                            description="tot 3 lagen"
                            autoFocus={false}
                            ps="&nbsp;"
                            onClick={() => { setBuildingType(buildingType.rowhouse) }} />
                        <BuildingTypeCard
                            active={buildingInitProps.type === buildingType.hybrid}
                            imageSrc="assets/building-types/05 hybride@2x.png"
                            title="Hybride"
                            autoFocus={false}
                            description="tot 8 lagen"
                            ps="(inclusief maisonettes)"
                            onClick={() => { setBuildingType(buildingType.hybrid) }} />
                    </span>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={styles.next}>
                    <Button color="primary" variant="contained" onClick={handleNext}>Volgende</Button>
                </div>
            </DialogActions>
        </>
    );
}

export default BuildingTypeSelectionDialog;
